<div
  class="editor-container"
  [class.editor-big]="size === 'big'"
  [class.editor-medium]="size === 'medium'"
  [class.editor-large]="size === 'large'"
  >
  <ngx-monaco-editor
    [disabled]="disabled"
    [options]="editorOptions"
    [(ngModel)]="code"
    (init)="editorInit($event)"
    (ngModelChange)="onDirChange($event)"
  ></ngx-monaco-editor>
</div>

@if (errors.length > 0) {
  <div class="error-container">
    <span class="error-title">
      {{ errors.length }}
      &nbsp;
      {{ errors.length > 1 ? 'Errors' : 'Error' }}
    </span>
    <div class="scrollable">
      <ul>
        @for (error of errors; track error) {
          <li>
            {{ error.message }}
            [{{ error.startLineNumber }}, {{ error.startColumn }}]
          </li>
        }
      </ul>
    </div>
  </div>
}
